// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Element from 'element-ui';
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import './sass/style.scss';
import App from './App';
import router from './router';

Vue.config.productionTip = false;
Vue.use(Element);

const apiUrl = window.location.hostname === 'localhost' ?
  'http://127.0.0.1:10010' :
  `https://api-${window.location.hostname}`;

Vue.mixin({
  data() {
    return {
      get apiUrl() {
        return apiUrl;
      },
    };
  },
});

/* eslint-disable no-new */
/* eslint-disable no-undef */
function googleAuth() {
  return axios({ method: 'GET', url: `${apiUrl}/public/config` })
  .then((result) => {
    const clientId = result.data.clientId;

    return new Promise((fulfill) => {
      gapi.load('auth2', () => {
        fulfill(clientId);
      });
    });
  })
  .then(clientId => gapi.auth2.init({
    client_id: clientId,
    hosted_domain: 'prestashop.com',
  }))
  .then(GoogleAuth => new Promise((fulfill, reject) => {
    // Check if the client is currently signed in
    if (!GoogleAuth.isSignedIn.get()) {
      GoogleAuth.signIn({
        prompt: 'consent',
        scope: 'profile email',
        ux_mode: 'redirect',
      })
      .then(() => {
        fulfill(GoogleAuth);
      })
      .catch((error) => {
        reject(error);
      });
    } else {
      fulfill(GoogleAuth);
    }
  }))
  .then((GoogleAuth) => {
    Vue.prototype.$GoogleAuth = GoogleAuth;
    const GoogleUser = GoogleAuth.currentUser.get();
    console.log('GoogleUser.getAuthResponse():', GoogleUser.getAuthResponse());
    Vue.prototype.$idToken = GoogleUser.getAuthResponse().id_token;

    // Instantiate a timer to refresh the token in 1 hour
    setTimeout(googleAuth, 3600000);
  });
}

const vm = new Vue({
  router,
  template: '<App/>',
  components: { App },
  beforeCreate: () => {
    // Get the app configuration from the server
    googleAuth()
    .then(() => {
      // Start the mounting of the Vue instance
      vm.$mount('#app');
    })
    .catch((error) => {
      console.error(error);
    });
  },
});



// WEBPACK FOOTER //
// ./src/main.js